var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height ma-0 pa-0",attrs:{"fluid":""}},[_c('medical-services-component'),_c('footer-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }